import React, { useEffect, useState } from 'react';
import Color from '../../../data/Color';
import Size from '../../../data/Size';
import { listen, unlisten } from '../../../dispatcher/Dispatcher';
import AppEvent from '../../../events/AppEvent';
import useCountdown from '../../../hooks/useCountdown';
import UIButton, { UIButtonWPopup } from '../../../ui/UIButton';
import UIContainer, { UIWhiteBox } from '../../../ui/UIContainer';
import UIFlex from '../../../ui/UIFlex';
import UIIcon from '../../../ui/UIIcon';
import UIInput from '../../../ui/UIInput';
import UITitle from '../../../ui/UITitle';
import BrowserUtil from '../../../util/BrowserUtil';
import './TransferNumber.scss';
import UIStatusBanner from '../../../ui/UIStatusBanner';
import Flex from '../../../data/Flex';

export interface ITransferNumberProps {
    
}

export function TransferNumber ($props: ITransferNumberProps) {

    const _onCountDownOver=()=>{

        setTransferNumber("");
        setCountDownOver(true);

    }

    const [curTime,startCountdown,stopCountdown] = useCountdown(0,_onCountDownOver);



    const [transferNumber, setTransferNumber] = useState("");

    const [isCountDownOver, setCountDownOver] = useState(false);

    const _onGenNum=($event:AppEvent)=>{

        let details = $event.data;

        if(details){
            if(details.transferNumber){
                if(details.expirationSeconds){
                    startCountdown(details.expirationSeconds);
                }
                setTransferNumber(details.transferNumber);
            }
        }

    }

    useEffect(()=>{
        setCountDownOver(false);  
        listen(AppEvent.GENERATED_911_TRANSFER_NUM, _onGenNum);

        return ()=>{
            unlisten(AppEvent.GENERATED_911_TRANSFER_NUM, _onGenNum);
            stopCountdown();
            setCountDownOver(true);
        }
    },[]);

    
    let numberIsEnabled:boolean=false;
    let transferInputCN:string = "transferInput";
    if(transferNumber){
        numberIsEnabled=true;
        transferInputCN+=" isEnabled";
    }

    //@ts-ignore
    var date = new Date(null);
    date.setSeconds(curTime); // specify value for SECONDS here
    var result = date.toISOString().substr(14,5);


    return (
        <UIContainer className='transferNumber' flex={{fullWidth:true,direction:Flex.COLUMN}}>
            <div className="divider"><UIIcon icon={UIIcon.CHEVRON_DOWN} fontSize={Size.s24}/></div>
            {curTime>0 && (
              <UIFlex className='validFor' flex={{style:{marginBottom:10}}}>
                Valid for {result} mins
            </UIFlex>
            )}
            <UIFlex flex={{fullWidth:true}}>
                <UIInput fontSize={Size.s26} className={transferInputCN} disabled={!numberIsEnabled} value={transferNumber} name="transferInput" flex={{style:{flexGrow:1, marginRight:0}}}/>
                
                <UIButtonWPopup 
                    hideCloseBtn
                    button={{color:Color.WHITE, disabled:!numberIsEnabled, isSquare:true, noPadding:true, icon:UIIcon.COPY, onClick:()=>{
                        BrowserUtil.copyToClipboard(transferNumber);
                    }}} 
                    popup={{noPadding:true,flex:{style:{padding:10}}}}>
                    Copied
                </UIButtonWPopup>

            </UIFlex>

            {curTime===0 && isCountDownOver && (
                <UIFlex flex={{style:{marginTop:10}}}>
                    <UIStatusBanner onClose={()=>{
                        setCountDownOver(false);

                    }}  status={{content:"The transfer number has expired. Please generate a new one.", type:UIStatusBanner.TYPE_ERROR, id:"countDownOver"}}/>
                </UIFlex>
            )} 

        </UIContainer>
        
    );
}
